import { getDefaultExportFromCjs } from " commonjsHelpers.js";
import { __require as requireCommonjs } from "/home/runner/work/html-dom-parser/html-dom-parser/node_modules/htmlparser2/dist/commonjs/index.js";
var commonjsExports = requireCommonjs();
export { commonjsExports as __moduleExports };
export default /*@__PURE__*/getDefaultExportFromCjs(commonjsExports);